import Loader from 'components/global/Loader';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const SimpleModal = ({
  show,
  onHide,
  title,
  children,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  size = 'md',
  centered = true,
  dialogClassName = '',
  headerClassName = 'bg-gray-800 text-white',
  bodyClassName = 'bg-gray-800 text-white',
  footerClassName = 'bg-gray-800 text-white',
  primaryButtonVariant = 'primary',
  secondaryButtonVariant = 'outline-gray-300',
  isLoading = false,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered={centered}
    size={size}
    dialogClassName={dialogClassName}
    enforceFocus={false}
  >
    <Modal.Header closeButton className={`${headerClassName} btn-close-white`}>
      <Modal.Title className="h5">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className={bodyClassName}>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Loader />
        </div>
      ) : (
        children
      )}
    </Modal.Body>
    {(primaryButtonText || secondaryButtonText) && (
      <Modal.Footer className={`justify-content-end ${footerClassName}`}>
        {secondaryButtonText && (
          <Button
            variant={secondaryButtonVariant}
            onClick={onSecondaryClick || onHide}
            className="rounded-pill"
            disabled={isLoading}
          >
            {secondaryButtonText}
          </Button>
        )}
        {primaryButtonText && (
          <Button
            variant={primaryButtonVariant}
            onClick={onPrimaryClick || onHide}
            className="rounded-pill"
            disabled={isLoading}
          >
            {primaryButtonText}
          </Button>
        )}
      </Modal.Footer>
    )}
  </Modal>
);

export default SimpleModal;
